<template>
  <header
    class="barocare-conci-header"
    :class="{'navigation': true, 'scrolled': isScrolled}"
    id="header"
  >
    <div class="container">
      <h1 id="logo">
        <a @click.prevent="scrollToTop" href="#home">
          <img src="../../assets/pc_barocare_conci/img-logo-white.png" alt="바로돌봄" class="logo-white" />
          <img src="../../assets/pc_barocare_conci/img-logo-primary.png" alt="바로돌봄" class="logo-primary" />
        </a>
      </h1>
      <ul class="gnb">
<!--        <li><router-link class="cta_001" to="/barocarenew/sub2">서비스 특장점</router-link></li>-->
        <li>
          <a class="cta_001" href="https://bit.ly/soldoc_introduction" target="_blank">서비스 소개</a></li>
        <li><router-link class="cta_002" to="/barocarenew/sub3">이용 방법</router-link></li>
        <li><router-link class="cta_003" to="/barocarenew/sub1">구매 가능 품목</router-link></li>
        <li><router-link class="cta_004" to="/barocarenew/sub5">인슐린 약국 지도</router-link></li>
        <li><router-link class="cta_005" to="/barocarenew/sub4">자주 묻는 질문</router-link></li>
      </ul>
      <div class="btn-area">
         <a
          href="https://baro.soldoc.co.kr/home"
          target="_blank" title="새창"
          class="cta_006 btn-go type3"
        >로그인 / 회원가입</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'BarocareConciHeader',
  data() {
    return {
      isScrolled: false
    };
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 210) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
    scrollToTop(event) {
      window.history.pushState({}, '', event.target.closest('a').href);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollToSection(event, sectionId, offset) {
      const section = document.getElementById(sectionId);
      if (section) {
        const y = section.getBoundingClientRect().top + window.pageYOffset + offset;

        window.history.pushState({}, '', event.target.closest('a').href);
        window.scrollTo({
          top: y,
        });
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciHeader.vue